const LightTheme = {
    colors: {
        background: '#F9FAFA',
        backgroundLight: '#FAFAFA',
        black: '#000',
        gray: '#EEEEEE',
        border: '#E0E0E0',
        error: '#EB1414',
        required: '#EB1414',
        info: '#1976d2',
        loadingBackground: '#e8e8e8',
        primary: {
            main: '#4739E7',
            dark: '#4739E7',
            light: '#EDECFD'
        },
        secondary: {
            main: '#37474F',
            background: '#000000',
            lightBackground: '#FFFFFF',
            hoverBackground: 'rgba(237, 236, 253, 1)',
            lighter: '#54626A'
        },
        text: {
            main: 'rgba(0, 0, 0, 0.87)',
            disabled: 'rgba(0, 0, 0, 0.38)',
            secondary: '#666666'
        },
        success: '#4CAF50',
        warning: '#ff8f00',
        white: '#fff',
        zoomGrey: '#292929',
        microsoft: {
            grey: '#5E5E5E',
            white: '#FFFFFF'
        },

        // copied from class-ui
        actions: {
            main: '#666666',
            background: '#EBEBEB',
            disabledBackground: '#E0E0E0',
            disabledText: '#BDBDBD'
        },
        other: {
            stroke: 'rgba(0, 0, 0, 0.23)',
            divider: '#E0E0E0',
            backdrop: 'rgba(0, 0, 0, 0.5)',
            snackbar: '#323232',
            outline: '#FFBA00',
            brandColor: '#4739E7'
        }
    },
    fonts: {
        fontFamily:
            "Lato, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
        codeFontFamily: 'Inconsolata, Menlo, Consolas, monospace'
    }
};

export default LightTheme;
